// this url is default emailbase url in settings
export const EMAIL_BASE_URL = 'https://localhost:6060';
